import type { FilterOperationSchema } from '../../types.js';

type Keys =
    | 'inArray'
    | 'equals'
    | 'doesNotEqual'
    | 'beginsWith'
    | 'endsWith'
    | 'containsLoose'
    | 'containsStrict'
    | 'doesNotContain';

export const STRING_FILTER_OPERATION: FilterOperationSchema<Keys> = {
    inArray: {
        id: 'inArray',
        label: 'Filterliste',
    },
    // ---
    containsLoose: {
        id: 'containsLoose',
        label: 'Enthält (locker)',
    },
    containsStrict: {
        id: 'containsStrict',
        label: 'Enthält (genau)',
    },
    doesNotContain: {
        id: 'doesNotContain',
        label: 'Enthält nicht',
    },
    // ---
    equals: {
        id: 'equals',
        label: 'Gleich',
    },
    doesNotEqual: {
        id: 'doesNotEqual',
        label: 'Ungleich',
    },
    // ---
    beginsWith: {
        id: 'beginsWith',
        label: 'Beginnt mit',
    },
    endsWith: {
        id: 'endsWith',
        label: 'Endet mit',
    },
} as const;

export type StringFilter = typeof STRING_FILTER_OPERATION;
export type StringFilterValues = StringFilter[keyof typeof STRING_FILTER_OPERATION];
export type StringFilterValuesWithoutInArray = Exclude<StringFilterValues, StringFilter['inArray']>;
